import i18n from './index';

/** 把对象上的中文文案换成 workbench 命名空间里的键，缺键时仍显示原来的中文。 */
export function bindCopy(target, key, fields) {
  fields.forEach((field) => {
    const fallback = target[field];
    if (typeof fallback !== 'string') return;
    Object.defineProperty(target, field, {
      enumerable: true,
      configurable: true,
      get() {
        return i18n.t(`${key}.${field}`, { ns: 'workbench', defaultValue: fallback });
      },
    });
  });
  return target;
}

export const NAV_LABEL_KEYS = {
  发布产品: 'publish',
  产品信息: 'productInfo',
  发布记录: 'records',
  草稿箱: 'drafts',
  产品模板: 'productTemplate',
  尺码库: 'sizeChart',
  属性库: 'attributes',
  品牌库: 'brands',
  发货仓库: 'shipWarehouse',
  运费模板: 'freight',
  模特库: 'model',
  实拍图库: 'photoLib',
  证书库: 'certificates',
  建议价资料库: 'rrpLibrary',
  合规资料: 'materials',
  包装合规: 'packing',
  商品广告: 'ads',
  寄样质检: 'sampleQc',
  订单列表: 'orderList',
  退货退款: 'returns',
  取消单: 'cancellations',
  经营数据: 'businessData',
  活动列表: 'activities',
  活动商品: 'enrollProducts',
  优惠券: 'coupons',
  首页: 'home',
  产品管理: 'products',
  产品合规: 'productCompliance',
  模板库: 'templates',
  营销活动: 'marketing',
  订单: 'orders',
  数据分析: 'analytics',
  财务账单: 'finance',
  店铺信息: 'shopInfo',
  仓库库存: 'stock',
  '商家改价（已下线）': 'discussOffline',
  '价格（已下线）': 'priceOffline',
  订单管理: 'orderManage',
  订单履约: 'fulfillment',
  仓库模板: 'warehouseTemplate',
  合规信息: 'complianceInfo',
  实拍图: 'realPhotos',
  证书资质: 'certQual',
  核价单: 'priceReview',
  调价单: 'priceAdjust',
  备货发货: 'stocking',
  打印中心: 'printCenter',
  销量数据: 'salesVolume',
  报名记录: 'enrollRecords',
  价格处理: 'priceHandle',
  合规资质: 'complianceQual',
  价格: 'price',
  议价单: 'discussOrders',
  建议零售价: 'suggestedRetail',
};

const boundNavItems = new WeakSet();

function bindNavLabel(item, key) {
  if (!item || typeof item !== 'object') return item;
  item.labelKey = key;
  if (boundNavItems.has(item)) return item;
  const fallback = item.label;
  item.labelFallback = fallback;
  Object.defineProperty(item, 'label', {
    enumerable: true,
    configurable: true,
    get() {
      return i18n.t(`platformNav.${key}`, { ns: 'workbench', defaultValue: fallback });
    },
  });
  boundNavItems.add(item);
  return item;
}

/** 给侧栏节点的 label 装上随语言变化的读取。同一节点重复调用不会覆盖原文。 */
export function bindNavLabels(items) {
  const walk = (list) => {
    (list || []).forEach((item) => {
      if (!item || typeof item !== 'object') return;
      const key = typeof item.label === 'string' ? NAV_LABEL_KEYS[item.label] : '';
      if (key) bindNavLabel(item, key);
      if (Array.isArray(item.children)) walk(item.children);
    });
  };
  walk(items);
  return items;
}

/** 复制菜单节点并保留 label 的动态读取。对象展开会把读取结果固化成当前语言。 */
export function copyNavItem(item, patch = {}) {
  const next = {};
  Object.keys(item).forEach((key) => {
    if (key === 'label') return;
    next[key] = item[key];
  });
  Object.assign(next, patch);
  if (!Object.prototype.hasOwnProperty.call(patch, 'label')) {
    const desc = Object.getOwnPropertyDescriptor(item, 'label');
    if (desc) Object.defineProperty(next, 'label', desc);
  }
  return next;
}
